import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import Dashboard from './routes/Publisher';
import { ErrorPage, NotFoundPage } from './components/ErrorHandler';
import Login from './routes/User/Login';
import Logout from './routes/User/Logout';
import { APIloader } from './Commons';
import PageWrap from './components/PageWrap';
import ClientDashboard from './routes/Client';

/*
Tailwind CSS helpers
https://tailwindcss.com/docs/
https://tailwindflex.com/ - component
https://www.hyperui.dev/ - more components
https://preline.co
*/

// react router
const router = createBrowserRouter([
  {
    path: '/*',
    element: <PageWrap><NotFoundPage /></PageWrap>,
    errorElement: <ErrorPage />,
  },
  {
    path: '/user',
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <NotFoundPage />,
      },
      {
        path: 'login',
        element: <PageWrap requireAuth={false}><Login /></PageWrap>,
        action: async ({ request }) => {
          return APIloader(request);
        }
      },
      {
        path: 'logout',
        element: <PageWrap requireAuth={true}><Logout /></PageWrap>,
        loader: async ({ request }) => {
          const userType = localStorage.getItem('userType');
          const req = new Request('/user/logout', { method: 'POST', body: new URLSearchParams({ type: userType }) });
          APIloader(req).then(() => {
            sessionStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('userType');
          });
        }
      },
    ]
  },
  {
    path: '/publisher',
    errorElement: <ErrorPage />,
    element: <PageWrap requireAuth={true}><Dashboard /></PageWrap>,
    loader: async ({request, params}) => {
      const req = new Request('/user/profile', {method: 'POST', body: new URLSearchParams({type: 'publisher'})}); // get user profile properties (name, PPC, etc.)
      return await APIloader(req, params);
    },
  },
  {
    path: '/client',
    errorElement: <ErrorPage />,
    element: <PageWrap requireAuth={true}><ClientDashboard /></PageWrap>,
    loader: async ({request, params}) => {
      const req = new Request('/user/profile', {method: 'POST', body: new URLSearchParams({type: 'client'})}); // get user profile properties (name, PPC, etc.)
      return await APIloader(req, params);
    }
  },
  {
    path: '/contactUS',
    action: async ({ request }) => {
      const formData = await request.formData();
      const userType = localStorage.getItem('userType');
      const actionPath = userType === 'publisher' ? '/publisher/contactUS' : '/client/contactUS';
      const req = new Request(actionPath, { method: 'POST', body: formData });
      return APIloader(req);
    },
    errorElement: <ErrorPage />,
  },
  { // dummy route for PageWrap to work (useRouteLoaderData) without breaking the "law of hooks"
    path: 'dummy-null-route',
    id: 'dummy-null-route',
    element: null,
    loader: () => {
      return null;
    }
  }
], {
  basename: '/',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <div className='flex gap-2'>
        <RouterProvider router={router} />
      </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
